export default __webpack_public_path__ + "static/media/Vector_search_icon.svg.d706c28e.png";